"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Lib = void 0;
const net = require("@ivanlog/net");
const models_1 = require("./models");
const models_2 = require("./models");
const models_3 = require("./models");
const models_4 = require("./models");
const models_5 = require("./models");
class Lib {
    constructor(_client, _errorsHandler) {
        this._client = _client;
        this._errorsHandler = _errorsHandler;
        if (!this._errorsHandler)
            this._errorsHandler = (e, args) => { throw e; };
    }
    rateAreasUnsafe() {
        return __awaiter(this, void 0, void 0, function* () {
            const __endpoint = "/driver/api/v1/Lib/RateAreas";
            const __query = [];
            const __addHeaders = {};
            __addHeaders['Accept'] = 'application/json';
            let __data;
            let __url = __endpoint;
            if (__query.length > 0)
                __url = __url + '?' + __query.join('&');
            const __responce = yield this._client.process(net.HTTPMethods.GET, __url, __data, __addHeaders, [200, 401, 403, 422, 500]);
            const __code = __responce.status;
            let __result;
            try {
                switch (__code) {
                    case 200:
                        __result = yield __responce.json();
                        for (const __rk in __result)
                            __result[__rk] = new models_1.RateArea(__result[__rk]);
                        break;
                    case 401:
                    case 403:
                    case 500: break;
                    case 422:
                        __result = new models_2.ResultFail(yield __responce.json());
                        break;
                    default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
                }
            }
            catch (e) {
                throw new net.NetError(net.HTTPCodes.BadDataFormat);
            }
            if ((__code >= 200) && (__code < 300)) {
                if (__result)
                    return __result;
                else
                    return __code;
            }
            else {
                if (__result)
                    throw __result;
                else
                    throw new net.NetError(__code);
            }
        });
    }
    /**
    * Get all rate areas
    * @param {unknown} errHndlArgs? args for errorsHandler
    * @returns {Promise<Array<RateArea>>}
    */
    rateAreas(errHndlArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const r = yield this.rateAreasUnsafe();
                if (!(Array.isArray(r)))
                    throw new net.NetError(net.HTTPCodes.UnknownResponse);
                else
                    return r;
            }
            catch (e) {
                this._errorsHandler(e, errHndlArgs);
            }
        });
    }
    ratesUnsafe() {
        return __awaiter(this, void 0, void 0, function* () {
            const __endpoint = "/driver/api/v1/Lib/Rates";
            const __query = [];
            const __addHeaders = {};
            __addHeaders['Accept'] = 'application/json';
            let __data;
            let __url = __endpoint;
            if (__query.length > 0)
                __url = __url + '?' + __query.join('&');
            const __responce = yield this._client.process(net.HTTPMethods.GET, __url, __data, __addHeaders, [200, 401, 403, 422, 500]);
            const __code = __responce.status;
            let __result;
            try {
                switch (__code) {
                    case 200:
                        __result = yield __responce.json();
                        for (const __rk in __result)
                            __result[__rk] = new models_3.Rate(__result[__rk]);
                        break;
                    case 401:
                    case 403:
                    case 500: break;
                    case 422:
                        __result = new models_2.ResultFail(yield __responce.json());
                        break;
                    default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
                }
            }
            catch (e) {
                throw new net.NetError(net.HTTPCodes.BadDataFormat);
            }
            if ((__code >= 200) && (__code < 300)) {
                if (__result)
                    return __result;
                else
                    return __code;
            }
            else {
                if (__result)
                    throw __result;
                else
                    throw new net.NetError(__code);
            }
        });
    }
    /**
    * Return all rates
    * @param {unknown} errHndlArgs? args for errorsHandler
    * @returns {Promise<Array<Rate>>}
    */
    rates(errHndlArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const r = yield this.ratesUnsafe();
                if (!(Array.isArray(r)))
                    throw new net.NetError(net.HTTPCodes.UnknownResponse);
                else
                    return r;
            }
            catch (e) {
                this._errorsHandler(e, errHndlArgs);
            }
        });
    }
    vehicleTypesUnsafe() {
        return __awaiter(this, void 0, void 0, function* () {
            const __endpoint = "/driver/api/v1/Lib/VehicleTypes";
            const __query = [];
            const __addHeaders = {};
            __addHeaders['Accept'] = 'application/json';
            let __data;
            let __url = __endpoint;
            if (__query.length > 0)
                __url = __url + '?' + __query.join('&');
            const __responce = yield this._client.process(net.HTTPMethods.GET, __url, __data, __addHeaders, [200, 401, 403, 422, 500]);
            const __code = __responce.status;
            let __result;
            try {
                switch (__code) {
                    case 200:
                        __result = yield __responce.json();
                        for (const __rk in __result)
                            __result[__rk] = new models_4.VehicleType(__result[__rk]);
                        break;
                    case 401:
                    case 403:
                    case 500: break;
                    case 422:
                        __result = new models_2.ResultFail(yield __responce.json());
                        break;
                    default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
                }
            }
            catch (e) {
                throw new net.NetError(net.HTTPCodes.BadDataFormat);
            }
            if ((__code >= 200) && (__code < 300)) {
                if (__result)
                    return __result;
                else
                    return __code;
            }
            else {
                if (__result)
                    throw __result;
                else
                    throw new net.NetError(__code);
            }
        });
    }
    /**
    * Get all vehicles types
    * @param {unknown} errHndlArgs? args for errorsHandler
    * @returns {Promise<Array<VehicleType>>}
    */
    vehicleTypes(errHndlArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const r = yield this.vehicleTypesUnsafe();
                if (!(Array.isArray(r)))
                    throw new net.NetError(net.HTTPCodes.UnknownResponse);
                else
                    return r;
            }
            catch (e) {
                this._errorsHandler(e, errHndlArgs);
            }
        });
    }
    commonUnsafe() {
        return __awaiter(this, void 0, void 0, function* () {
            const __endpoint = "/driver/api/v1/Lib/Common";
            const __query = [];
            const __addHeaders = {};
            __addHeaders['Accept'] = 'application/json';
            let __data;
            let __url = __endpoint;
            if (__query.length > 0)
                __url = __url + '?' + __query.join('&');
            const __responce = yield this._client.process(net.HTTPMethods.GET, __url, __data, __addHeaders, [200, 401, 403, 422, 500]);
            const __code = __responce.status;
            let __result;
            try {
                switch (__code) {
                    case 200:
                        __result = new models_5.LibCommonData(yield __responce.json());
                        break;
                    case 401:
                    case 403:
                    case 500: break;
                    case 422:
                        __result = new models_2.ResultFail(yield __responce.json());
                        break;
                    default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
                }
            }
            catch (e) {
                throw new net.NetError(net.HTTPCodes.BadDataFormat);
            }
            if ((__code >= 200) && (__code < 300)) {
                if (__result)
                    return __result;
                else
                    return __code;
            }
            else {
                if (__result)
                    throw __result;
                else
                    throw new net.NetError(__code);
            }
        });
    }
    /**
    * Get common lib's entities
    * @param {unknown} errHndlArgs? args for errorsHandler
    * @returns {Promise<LibCommonData>}
    */
    common(errHndlArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const r = yield this.commonUnsafe();
                if (!(r instanceof models_5.LibCommonData))
                    throw new net.NetError(net.HTTPCodes.UnknownResponse);
                else
                    return r;
            }
            catch (e) {
                this._errorsHandler(e, errHndlArgs);
            }
        });
    }
}
exports.Lib = Lib;
//# sourceMappingURL=Lib.js.map